<form [formGroup]="form" (ngSubmit)="submitForm()">
  <form action=""></form>
  <title mat-dialog-title>{{ isNew ? ('common.addView' | t) : ('common.editView' | t) }}</title>
  <mat-dialog-content>
    <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button color="danger" (click)="close()">{{ 'common.close' | t }}</button>
    <button mat-button color="success" type="submit" [mtBasicSpinner]="isLoading">{{ 'common.submit' | t }}</button>
  </mat-dialog-actions>
</form>
